export default class {
  constructor(el) {
    this.el = el;
    this.step = 0
  }

  init() {
    let observer = new IntersectionObserver((entry, observer) => {
      if(entry[0].isIntersecting) {
        const counters = this.el.querySelectorAll('.count');
        const speed = 1000;

        counters.forEach(counter => {
          const animate = () => {
            const value = +counter.getAttribute('data-count');
            const data = +counter.innerText;

            const time = value / speed;

            if(data < value) {
              counter.innerText = Math.ceil(data + time * 10);
              setTimeout(animate, 10);
            }else{
              counter.innerText = value;
            }
            this.step = 1;
          }

          animate();
        });

       }
    });
    observer.observe(this.el);
  }

  destroy() {
    this.scrollCounter.destroy()
  }
}
